import {
  ACQUISITION_DETAIL_NOT_BIDDABLE_LIST, ACQUISITION_DETAIL_NOT_BIDDABLE_LIST_SUCCESS, ACQUISITION_DETAIL_NOT_BIDDABLE_LIST_ERROR,
  ACQUISITION_DETAIL_NOT_BIDDABLE_ADD, ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_SUCCESS, ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_ERROR, ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_CHANGE,
  ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE, ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE_SUCCESS, ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE_ERROR,
  ACQUISITION_FILTER_DETAIL_TYPE_NOT_BIDDABLE_SUCCESS,
} from '../../actions';

const INIT_STATE = {
  loading: true,
  list: { header: { name: 'code', order: 'sorted-asc' }, page: { current: 1, rows: 1000 }, data: [], total_pages: 1 },
  add: { data: { new: { name: '', id_acquisition_detail_type: '' } }, loading: false, message: '' },
  edit: { update: { loading: false, response: '', message: '' } },
  filters: { detail_types_not_biddable: [] },
  error: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ACQUISITION_DETAIL_NOT_BIDDABLE_LIST: return { ...state, loading: true };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_LIST_SUCCESS: return { ...state, loading: false, list: { ...state.list, ...action.payload } };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_LIST_ERROR: return { ...state, loading: false, error: true };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_CHANGE: return { ...state, add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } } };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_ADD: return { ...state, add: { ...state.add, loading: true } };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_SUCCESS: return { ...state, add: { ...state.add, loading: false, message: action.payload.message, data: { new: { name: '', id_acquisition_detail_type: state.add.data.new.id_acquisition_detail_type } } } };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_ADD_ERROR: return { ...state, add: { ...state.add, loading: false, message: action.payload.message } };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE: return { ...state, edit: { ...state.edit, update: { loading: true, response: '', message: '' } } };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE_SUCCESS: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'success', message: action.payload } } };
    case ACQUISITION_DETAIL_NOT_BIDDABLE_UPDATE_ERROR: return { ...state, edit: { ...state.edit, update: { loading: false, response: 'error', message: action.payload } } };
    case ACQUISITION_FILTER_DETAIL_TYPE_NOT_BIDDABLE_SUCCESS: return { ...state, filters: { ...state.filters, detail_types_not_biddable: action.payload } };
    default: return { ...state };
  }
};
